<template>
	<v-dialog
			:value="isGenerateFilePPW"
			content-class="dialogWrapper"
			persistent
			width="840"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>Generate PPW file</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<main-table
						padding="0"
						:flag="flag"
						:headers="getHeaders"
						:listItems="items"
						@updateClickButton="onClickButton($event, flag)"
						:is-hide-header="false"
						:items-per-page-amount="10"
						:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"

						:indeterminate="indeterminate"
						:checkAll="checkAll"
						@updateCheckOrder="onCheckOrder"
						@updateCheckOrders="onCheckOrders"
				></main-table>
			</div>
			<div class="dialogFooter">
				<div class="buttonGroups">
					<custom-btn
							margin="0"
							text="CANCEL"
							custom-class="cancel"
							@updateEvent="onClose"
					></custom-btn>
					<custom-btn
							margin="0"
							text="Generate file"
							custom-class="apply"
							:disabled="isDisabled"
							@updateEvent="onGenerateFile"
					></custom-btn>
				</div>
			</div>
		</div>
	</v-dialog>
</template>

<script>
import { tablePPWFiles } from "@/components/Dispatch/Trips/DialogTrip/constants";

export default {
	name: "GenerateFilePPW",
	props: {
		items: Array,
	},
	computed: {
		getHeaders() {
			return tablePPWFiles;
		},
		isDisabled() {
			return this.selected.length === 0;
		},
	},
	data: () => ({
		flag: 'GenerateFilePPW',
		isGenerateFilePPW: true,

		checkAll: false,
		selected: [],
		indeterminate: false,

	}),
	methods: {
		onCheckOrder(orderId) {
			const idx = this.selected.findIndex(({ id }) => id === orderId);
			const item = this.items.find(({ id }) => id === orderId);
			if (idx === -1) {
				this.selected.push(item);
			} else {
				this.selected.splice(idx, 1);
			}

			if (!this.selected.length) {
				this.indeterminate = false;
				this.checkAll = false;
			}

			if (this.selected.length && this.selected.length !== this.items.length) {
				this.indeterminate = true;
			}

			if (this.selected.length === this.items.length) {
				this.indeterminate = false;
				this.checkAll = true;
			}
		},
		onCheckOrders(value) {
			if (value) {
				this.selected = this.items.map((body) => body);
			} else {
				this.selected = [];
				this.indeterminate = false;
			}

			this.checkAll = value;
			this.items.forEach((item) => (item.isCheck = value));
		},

		onClickButton({ key, item }, nameComponent) {
			this.$emit('updatePPWFilesClickButton', { key, item, nameComponent });
		},
		onGenerateFile() {
			this.$emit('updateGeneratePPWFilesSelected', this.selected);
		},
		onClose() {
			this.$emit('updateClose');
		},
	}
};
</script>

<style scoped lang="scss">
@import "../../dialog";
</style>
